<script lang="ts">
    import { page } from '$app/stores';
    import ROUTE_IDS from '$src/generated/routeIds';
    import { MARKET_SLUGS } from '$src/lib/services/market/slugs';
    import { isActiveRoute, navigate } from '$src/lib/services/navigation';
    import { getHashStore } from './hash';

    const isRegisterPage = isActiveRoute(ROUTE_IDS.REGISTER);
    const hash = getHashStore();

    $: market = $page.data.market.slug;
    $: redirectHash = market === MARKET_SLUGS.SV ? 'playnow' : 'signup';
    $: isMigration = $page.url.pathname.includes('migration');
    $: shouldRedirectForRegistration = $hash === redirectHash;

    $: if (!$isRegisterPage && !isMigration && shouldRedirectForRegistration) {
        navigate(ROUTE_IDS.REGISTER);
    }
</script>
